import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findDepositRecord= (params) => {
    params.rechargeClientType='JOINS_MERCHANT'
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/pledge?`+params,
        method: 'GET'
    })
}